export const plotters = [
  { brand: "WorkHorse", models: ["WorkHorse", "WorkHorse2"] },
  { brand: "EcoCut", models: ["EcoCut Series"] },
  { brand: "Roland", models: ["GX-Series", "CX-Series", "GS-Series (GS-24)", "CAMM-1 Series"] },
  { brand: "Graphtec", models: ["FC-9000 Series", "FC-8600 Series", "FC-8000 Series", "CE-6000 Series", "CE-7000 Series", "CE-Lite 50"] },
  { brand: "GCC", models: ["Jaguar V Series", "Jaguar IV", "Puma3", "Puma IV", "Expert II 52", "Expert II 24"] },
  { brand: "US Cutter", models: ["US Cutter LaserPoint", "US Cutter LazerPoint 3", "US Cutter SC", "US Cutter SC2", "Titan Series", "MH Series"] },
  { brand: "Vevor", models: ["Vevor AB-1350", "Vevor B-1350", "Vevor KI-1350", "Vevor KI-870", "Vevor KI-720"] },
];
